import { Accordion, ServiceCard, WhyJoin, useText } from '@kkf/design'
import { SERVICES, WHY_JOIN } from '../data/services'
import { VOLUNTEER_FAQS } from '../data/faqs'
import { useT } from '../i18n'

/** The services page. */
export function ServicesPage() {
  const t = useT()
  const s = useText()
  return (
    <>

      {/* SERVICES */}
      {/*
        No banner and no breadcrumb (2026-09-21), the way `/about`, `/contact`, `/blog` and
        the legal pair lost theirs. `Breadcrumb` IS the photographic band — the trail sat
        inside it — so both went together. Two things travel with that, and each passes
        every gate this repo has:

        1. **It carried the page's only `<h1>`.** `audit:seo` fails a page with any number
           other than one, so the title is `.ul-plain-page-title` here — the class that
           exists for exactly this, beside `.ul-plain-page-top` in `_header.scss`.
        2. **The page now opens pale**, and the header's links are white at rest because
           the usual first section is a dark band. This route is in `header.plainRoutes`
           in `data/shell` as of the same day. Forget that and every link in the nav is
           white on near-white, and nothing anywhere goes red.
      */}
      <section className="ul-plain-page-top ul-section-spacing overflow-hidden">
        <div className="ul-container">
          <h1 className="ul-plain-page-title">{t('page.services')}</h1>
          <div className="row row-cols-md-3 row-cols-2 row-cols-xxs-1 ul-bs-row">
            {SERVICES.map((service, i) => (
              <div className="col" key={`${service.image}-${i}`}>
                {/* The card takes plain strings; the entry carries both languages. */}
                <ServiceCard
                  {...service}
                  title={s(service.title)}
                  descr={s(service.descr)}
                  imageAlt={service.imageAlt ? s(service.imageAlt) : undefined}
                  variant="inner"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <WhyJoin
        {...WHY_JOIN}
        subTitle={s(WHY_JOIN.subTitle)}
        title={s(WHY_JOIN.title)}
        descr={s(WHY_JOIN.descr)}
        variant="wrapped"
      >
        <Accordion items={VOLUNTEER_FAQS} />
      </WhyJoin>
    </>
  )
}
